export default ({ getRoot }) => state => {
  const root = getRoot(state);

  return root.get('limit');
};
